<template>
    <div class="col-md-6 col-sm-12 mt-4">
        <div class="fb-div">
            <div class="circular--portrait">
                <div class="text-center mt-4">
                    <img src="../assets/disfruta.png"/>
                </div>
            </div>
            <p class="title-sub mt-5 text-center">Hola soy Thomas tu asistente virtual</p>
            <p class="title-sub-2 text-center">Pre-carga datos con:</p>
            <p class="text-center">Algunos de tus datos pueden ser rellenados automáticamente con:</p>
            <div class="col text-center">
                <button class="btn btn-default btn-custom1"><font-awesome-icon :style="{ marginRight: '20px'}" size="1x"  :icon="['fab', 'facebook-f']" />Carga tus datos de Facebook</button>
            </div>
        </div>
    </div>    
</template>

<script>
export default {
  name: 'StepFB'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
